module.exports = __webpack_public_path__ + "static/fipcunicorn3-eb49dfa6d01969e27dafbfce2e114191.jpeg";